<template>
  <div>
    <v-snackbar v-if="entities" v-model="snackbar" :vertical="false" timeout="-1">
      <v-btn color="red" text outlined :href="entities[0].admin_route" block>
        <div class="d-inline-block text-truncate" style="max-width: 180px">
          {{ entities[0].title }}
        </div>
      </v-btn>

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      snackbar: true,
    };
  },
  computed: {
    entities() {
      const entities = this.$store.state.entities;
      if (!this.$store.state.auth || !entities || entities.length === 0) return false;

      return entities;
    },
  },
};
</script>
